import React, { useRef, useState } from "react";
import { IPermissionProps } from "../../../models/Login";
import Table from "./Table";
import { Toast } from "primereact/toast";
import Form from "./Form";

export interface IModel {
  open: boolean;
}

const MonsterSetting = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ open: false } as IModel);
  const [reload, setReload] = useState(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ open: false });
  };
  return (
    <>
      <Table permissions={permissions} reload={reload} setModal={setModal} toast={toast} />
      <Form open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};

export default MonsterSetting;
